// The ONE reading of `environment.streaming`. ReunionStreamingService (guide, sessions,
// the public PMU gateway) and TokenInterceptor (which origins receive the Firebase token
// and x-racebet-sec) both decide through it, so the two gates cannot drift: an apiUrl the
// service treats as off never receives our credentials either.
//
// Returns the API base URL without a trailing slash when streaming is on, else ''.
// On means `enabled === true` AND an http(s) apiUrl with a host.
export function streamingApiUrl(env: any): string {
  const config = env && env.streaming;
  if (!config || config.enabled !== true || typeof config.apiUrl !== 'string') {
    return '';
  }
  const apiUrl = config.apiUrl.trim().replace(/\/+$/, '');
  return /^https?:\/\/[^/?#]+/i.test(apiUrl) ? apiUrl : '';
}
